import { render, staticRenderFns } from "./pagination-left.vue?vue&type=template&id=35f2cd9b&"
import script from "./pagination-left.vue?vue&type=script&lang=js&"
export * from "./pagination-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports